import axios from 'axios';

import type { CapacityAgreementJsonType, CapacityAgreementUpdateJsonType } from './types';

const policyCapacityApiPath = ({
  organizationId,
  policyId,
  isManualPolicy,
}: {
  organizationId: number;
  policyId: number;
  isManualPolicy: boolean;
}) => {
  return `/api/v1/organizations/${organizationId}/policy_capacity/${policyId}/${isManualPolicy ? 'manual_policy' : 'api_policy'}`;
};

export const createCapacityAgreement = async ({
  organizationId,
  policyId,
  json,
  isManualPolicy,
}: {
  organizationId: number;
  policyId: number;
  json: CapacityAgreementJsonType;
  isManualPolicy: boolean;
}): Promise<void> => {
  await axios.post(policyCapacityApiPath({ organizationId, policyId, isManualPolicy }), json);
};

export const updateCapacityAgreement = async ({
  organizationId,
  policyId,
  json,
  isManualPolicy,
}: {
  organizationId: number;
  policyId: number;
  json: CapacityAgreementUpdateJsonType;
  isManualPolicy: boolean;
}): Promise<void> => {
  await axios.patch(policyCapacityApiPath({ organizationId, policyId, isManualPolicy }), json);
};
